import breed from "./breed";

function dealTime(timeStamp) {
  let dealTime = new Date(timeStamp).getTime();
  let curTime = new Date().getTime();
  let subTime = parseInt((curTime - dealTime) / 1000);

  let timestr = "";
  if (parseInt(subTime / (24 * 60 * 60 * 30)) > 0) {
    timestr = parseInt(subTime / (24 * 60 * 60 * 30)) + "个月前";
  } else if (parseInt(subTime / (24 * 60 * 60)) > 0) {
    timestr = parseInt(subTime / (24 * 60 * 60)) + "天前";
  } else if (parseInt(subTime / (60 * 60)) > 0) {
    timestr = parseInt(subTime / (60 * 60)) + "个小时前";
  } else {
    timestr = "刚刚";
  }
  return timestr;
}

function changeFormat(pubInfo, option = {}) {
  for (let [index, value] of pubInfo.city.entries()) {
    if (value.endsWith("市")) {
      pubInfo.city = value;
      break;
    }
  }
  if (pubInfo.type === 0) {
    pubInfo.type = "流浪";
  } else if (pubInfo.type == 1) {
    pubInfo.type = "家养";
  } else if (pubInfo.type == 3) {
    pubInfo.type = "收养所";
  }
  if (pubInfo.gender === 1) {
    pubInfo.gender = "GG";
  } else if (pubInfo.gender === 2) {
    pubInfo.gender = "MM";
  }
  if (pubInfo.status === 0) {
    pubInfo.status = "待领养";
  } else if (pubInfo.status === 1) {
    pubInfo.status = "已领养";
  }

  if (pubInfo.hasOwnProperty("is_immune")) {
    if (pubInfo.is_immune == true) {
      pubInfo.is_immune = "是";
    } else {
      pubInfo.is_immune = "否";
    }
  }
  if (pubInfo.hasOwnProperty("is_deinsect")) {
    if (pubInfo.is_deinsect == true) {
      pubInfo.is_deinsect = "是";
    } else {
      pubInfo.is_deinsect = "否";
    }
  }
  if (pubInfo.hasOwnProperty("is_sterilized")) {
    if (pubInfo.is_sterilized == true) {
      pubInfo.is_sterilized = "是";
    } else {
      pubInfo.is_sterilized = "否";
    }
  }
  if (pubInfo.hasOwnProperty("owner_type")) {
    if (pubInfo.owner_type == 0) {
      pubInfo.owner_type = "个人";
    } else {
      pubInfo.owner_type = "机构";
    }
  }
  pubInfo.price_status = ["无偿", "收押金", "有偿"][pubInfo.price_status || 0];

  let createTime = new Date(pubInfo.create_at).getTime();
  let curTime = new Date().getTime();
  let subTime = parseInt((curTime - createTime) / 1000);

  if (parseInt(subTime / (24 * 60 * 60 * 30)) > 0) {
    pubInfo.timestamp = parseInt(subTime / (24 * 60 * 60 * 30)) + "个月前";
  } else if (parseInt(subTime / (24 * 60 * 60)) > 0) {
    pubInfo.timestamp = parseInt(subTime / (24 * 60 * 60)) + "天前";
  } else if (parseInt(subTime / (60 * 60)) > 0) {
    pubInfo.timestamp = parseInt(subTime / (60 * 60)) + "个小时前";
  } else {
    pubInfo.timestamp = "刚刚";
  }
  if (option.img && option.img.dst) {
    pubInfo.dstPicture = pubInfo.picture.map(single => {
      single = single.replace("http://", "https://");
      return single + option.img.dst;
    });
  }
  if (pubInfo.picture) {
    pubInfo.picture = pubInfo.picture.map(single => {
      single = single.replace("http://", "https://");
      if (option.img && option.img.src) {
        return single + option.img.src;
      }
      return single + "?x-oss-process=image/resize,m_fill,h_300,w_300";
    });
  }
  pubInfo.src_breeding = pubInfo.breeding;
  pubInfo.breeding = breed.getBreedName(pubInfo.breeding);
  if (pubInfo.src && pubInfo.src.includes("maomilingyang")) {
    pubInfo.breeding = "猫咪";
  }
  return pubInfo;
}

export default {
  changeFormat: changeFormat,
  dealTime: dealTime
};
